"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var IconImage = __importStar(require("./M_IconImage"));
var LoadingButtonWExplanation = __importStar(require("./M_LoadingButtonWithExplanation"));
var Button = __importStar(require("./A_Button"));
// Created for ar runway, kinda specific, avoid reuse
var Component = function (p) {
    var _a;
    return (Preact.h(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', borderRadius: '16px', overflow: 'hidden' } },
        Preact.h(IconImage.Component, { Icon: function () { return Preact.h(Close_1.default, null); }, image: p.image, onIconClick: p.onCloseClick }),
        Preact.h(Box_1.default, { bgcolor: "background.default", sx: { p: 3 } },
            Preact.h(LoadingButtonWExplanation.Component, { buttonText: p.buttonText, explanation: p.modalText, onClick: p.onButtonClick, disabled: (_a = p.disabled) !== null && _a !== void 0 ? _a : false, loading: p.loading, error: p.error }),
            p.secondaryButton ? (Preact.h(Button.Component, { color: "primary", variant: "outlined", size: "medium", fullWidth: true, onClick: p.secondaryButton.onClick, sx: { mt: 3, textTransform: 'none' }, classes: {} }, p.secondaryButton.text)) : null)));
};
exports.Component = Component;
